import { RoadmapModel as Model } from './Model'


export const MODULE_NAME = 'roadmaps'

export const ROADMAPS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: ROADMAPS_ROUTES.LAYOUT,
  route: { name: ROADMAPS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-map-legend',
} as const
